// #### DIRECT SELECTORS
export const selectTableColumns = (state, aid) => state.table.columns[aid]
export const selectTableTabColumns = (state, aid) => state.table.tabColumns[aid]
export const selectTableTabs = (state, aid) => state.table.table[aid]?.data?.tabs
export const selectTableVariables = (state, aid) => state.table.table[aid]?.data?.variables
// Local model props
export const selectTableIsDesigning = (state, aid) => state.table.isDesigning[aid]
